import React, { useEffect, useState } from 'react'
import { Button, Form, message, Popover, Radio, Select } from 'antd'
import { useStoreState, useStoreActions } from 'easy-peasy'

import FormItem from '../FormItem'
import { AI_SUGGESTIONS } from 'Constants/aiSuggestions'
import OnelifeAppPushSchema, { AI_SCHEMAS } from './constants'

const aiChecks = AI_SUGGESTIONS

export default function AppPushChanel() {
  const { content, selected_dynamic_param } = useStoreState((state) => state.campaignModule)
  const { setState } = useStoreActions((action: any) => action.campaignModule)
  const [model, setModel] = useState<string>(content?.mode || 'dynamic')
  const [form] = Form.useForm()
  const [openSelectAi, setOpenSelectAi] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  useEffect(() => {
    setState({ key: 'isContentValidated', value: false })
    setState({ key: 'content', value: { ...content, mode: content?.mode || 'dynamic' } })
  }, [])

  const onFinish = () => {
    message.success('Content is validated')
    setState({ key: 'isContentValidated', value: true })
    if (!content?.mode) {
      setState({ key: 'content', value: { ...content, mode: 'dynamic' } })
    }
  }

  const renderBody = () => {
    return (
      <Form
        layout="vertical"
        name="ContentForm"
        labelCol={{ span: 12 }}
        wrapperCol={{ span: 24 }}
        requiredMark
        onFinish={onFinish}
        initialValues={content}
        scrollToFirstError
        form={form}
      >
        <div>
          <div className="mb-2 font-semibold">Type</div>
          <Radio.Group
            onChange={(e) => {
              setModel(e.target.value)
              form.setFieldsValue({ mode: e.target.value })
              setState({ key: 'isContentValidated', value: false })
              setState({ key: 'content', value: { ...content, mode: e.target.value } })
            }}
            value={model}
            className="mb-4"
          >
            <Radio value={'dynamic'}>Dynamic</Radio>
            <Radio value={'generate'}>AI generated</Radio>
          </Radio.Group>
        </div>
        <div className="mb-4">
          <div className=" font-semibold">AI Suggestion Type</div>
        </div>
        <Select
          className=" cursor-pointer w-full"
          options={aiChecks?.map((ai) => ({
            label: ai?.name,
            value: ai?.code,
          }))}
          value={content?.type || content?.subType}
          open={openSelectAi}
          onDropdownVisibleChange={(visible) => {
            setOpenSelectAi(visible)
          }}
          dropdownRender={() => {
            return (
              <div className="w-full gap-3 rounded">
                {aiChecks.map((ai) => {
                  if (ai?.options?.length) {
                    return (
                      <div className="pb-0" key={ai?.code}>
                        <div>
                          <div className="h-10 flex items-center pl-4">{ai.name}</div>
                          <div className="flex gap-2 flex-col cursor-pointer">
                            {ai?.options?.map((option) => (
                              <div
                                className=" cursor-pointer h-10 flex items-center hover:bg-gray-100 pb-0 pl-8 text-gray-500"
                                key={option?.code}
                                onClick={() => {
                                  form.setFieldsValue({
                                    type: ai?.code,
                                    params: ai?.params,
                                    subType: option?.code,
                                  })
                                  setState({ key: 'isContentValidated', value: false })
                                  setState({
                                    key: 'content',
                                    value: {
                                      ...content,
                                      type: ai?.code,
                                      params: ai?.params,
                                      subType: option?.code,
                                    },
                                  })
                                  setOpenSelectAi(false)
                                }}
                              >
                                {option?.name}
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    )
                  }
                  return (
                    <div
                      className=" cursor-pointer h-10 flex items-center hover:bg-gray-100 pl-4"
                      key={ai?.code}
                      onClick={() => {
                        form.setFieldsValue({ type: ai?.code, params: ai?.params })
                        setState({ key: 'isContentValidated', value: false })
                        setState({
                          key: 'content',
                          value: { ...content, type: ai?.code, params: ai?.params },
                        })
                        setOpenSelectAi(false)
                      }}
                    >
                      {ai.name}
                    </div>
                  )
                })}
              </div>
            )
          }}
          placeholder="Choose AI Suggestion Type"
        ></Select>
        <div className="mb-4"></div>
        {model === 'generate' ? (
          <div className=" flex flex-col gap-3">
            {AI_SCHEMAS?.map((schema: any) => (
              <Form.Item
                key={schema.name}
                label={schema.label}
                tooltip={schema.tooltip}
                className={schema.className || ''}
                name={schema.name}
                shouldUpdate={(prevValues, currentValues) => {
                  if (prevValues[schema.name] !== currentValues[schema.name]) return true
                  return false
                }}
                rules={[
                  ...(schema.isRequired
                    ? [
                        {
                          required: schema.isRequired,
                          message: `${schema.label} is required`,
                        },
                      ]
                    : []),
                  ...(schema.validatePattern
                    ? [
                        {
                          pattern: schema.validatePattern,
                          message: `${schema.label} doesn't match the pattern`,
                        },
                      ]
                    : []),
                ]}
                initialValue={schema.defaultValue}
              >
                <FormItem
                  name={schema?.name}
                  type={schema?.type}
                  value={form.getFieldValue(content && content[schema?.name])}
                  options={schema.options}
                  placeholder={schema.placeholder || ''}
                  onChange={(name, value) => {
                    form.setFieldsValue({ [name]: value })
                    setState({ key: 'isContentValidated', value: false })
                    setState({ key: 'content', value: { ...content, [name]: value } })
                  }}
                />
              </Form.Item>
            ))}
          </div>
        ) : (
          <>
            {OnelifeAppPushSchema?.map((schema: any) => (
              <Form.Item
                key={schema.name}
                label={schema.label}
                tooltip={schema.tooltip}
                className={schema.className || ''}
                name={schema.name}
                shouldUpdate={(prevValues, currentValues) => {
                  if (prevValues[schema.name] !== currentValues[schema.name]) return true
                  return false
                }}
                rules={[
                  ...(schema.isRequired
                    ? [
                        {
                          required: schema.isRequired,
                          message: `${schema.label} is required`,
                        },
                      ]
                    : []),
                  ...(schema.validatePattern
                    ? [
                        {
                          pattern: schema.validatePattern,
                          message: `${schema.label} doesn't match the pattern`,
                        },
                      ]
                    : []),
                ]}
                initialValue={schema.defaultValue}
              >
                <FormItem
                  name={schema?.name}
                  type={schema?.type}
                  value={form.getFieldValue(content && content[schema?.name])}
                  options={schema.options}
                  placeholder={schema.placeholder || ''}
                  onChange={(name, value) => {
                    form.setFieldsValue({ [name]: value })
                    setState({ key: 'isContentValidated', value: false })
                    setState({ key: 'content', value: { ...content, [name]: value } })
                  }}
                  dynamicParams={content?.params}
                />
              </Form.Item>
            ))}
          </>
        )}
      </Form>
    )
  }
  return <div>{renderBody()}</div>
}
